import { atom } from 'jotai'

export const legalNoticeDrawerAtom = atom({ isOpen: false, content: '' })
